import React, {Fragment, useEffect, useRef, useState} from "react";
import {Link, NavLink, useLocation,useParams} from "react-router-dom";
import '../../assets/cssnew/Home.css';
import axios from "axios";
import clientconfigwebapp, {
    Agent_by_user_get_appbk,
    check_login_appbk, empty_bk,
    FormatNumberByhkh,
    get_first_last_name_local, modal_select_agent_show_hide,
    scrollTo_uphk, seo_setmetabk, Token_get_appbk
} from "../../clientconfigwebapp";
import {toast, ToastContainer} from "react-toastify";
import Grid from '@mui/material/Grid';
import bg_baner_bottom_home from '../../assets/images/bg-baner-bottom-home.jpg';

import LazyLoad from 'react-lazy-load';
import {Skeleton} from "@mui/material";


import Header from "../../components/Header/Header";
import Home_Baner_Search from "./Parts/Home_Baner_Search";
import Home_Section_B from "./Parts/Home_Section_B";
import Home_Section_C from "./Parts/Home_Section_C";
import Home_Section_D from "./Parts/Home_Section_D";
import Home_Section_E from "./Parts/Home_Section_E";
import Home_Section_F from "./Parts/Home_Section_F";
import Home_Section_G from "./Parts/Home_Section_G";
import Home_Section_I from "./Parts/Home_Section_I";
import Home_Section_J from "./Parts/Home_Section_J";

import baner_img_1 from "../../assets/images/baner1-new.jpg";
import baner_img_2 from "../../assets/images/baner2-new.jpg";


import Footercom from "../../components/Footer/Footercom";
import * as url from "url";
function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Home = (props) => {
    const location_get_urlbk = useLocation();

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile,setData_first_name_profile] = useState('');
    const [last_name_profile,setData_last_name_profile] = useState('');
    /*  end profile */


    let query = useQuery();
  const {id_cat_getuser} = useParams();


    const is_device_boxbk = window.matchMedia("(max-width: 700px)");
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);


    const [data_slider_list, set_data_slider_list] = useState([]);
    const [data_category_box, set_data_category_box] = useState([]);
    const [Requests_last, set_data_Requests_last] = useState([]);
    const [Coments_last, set_data_Comments_last] = useState([]);



    const [data_list_posts, set_list_post_Data] = useState([]);
    const [data_paged_info, set_data_paged_info] = useState([]);



    const [activeSection, setActiveSection] = useState('sec-1');

    const [scrollY, setScrollY] = useState(0);


    /* paged start */
    let page_number=query.get("page");
    const page = useRef();
    function paginationStyle (e) {
        const list = page.current.childNodes;
        for (let index = 0; index < list.length; index++) {
            const element = list[index];
            element.className = "";
        }
        e.target.className = "active-page"
    }
    /* paged end */
    function logit() {
        setScrollY(window.pageYOffset);
    }



    useEffect(() => {

        scrollTo_uphk();
        Load_api_page();


    }, [location_get_urlbk]);



    useEffect(() => {
        window.addEventListener('resize', setWindowDimensions);
        return () => {
            window.removeEventListener('resize', setWindowDimensions)
        }
    }, []);


    const setWindowDimensions = () => {
        setWindowWidth(window.innerWidth)
    }


    const handleLinkClick = (section) => {
        setActiveSection(section);
        scrollToSection(section);
    };

    const scrollToSection = (section) => {
        const element = document.getElementById(section);
    };





    const Load_api_page= () => {

        var config = null;

        if(check_login_appbk()==true){
            config = {
                headers: { Authorization: `Bearer ${Token_get_appbk()}` }
            };
        }

        set_list_post_Data([]);


        seo_setmetabk({
            title: "بازارانو | بازار خرید و فروش عمده انواع محصولات.",
            metaDescription: "بازار خرید و فروش عمده انواع محصولات.",
        });


        var post_get_user="";
      if(!empty_bk(id_cat_getuser)){ post_get_user=String(id_cat_getuser);  }


       /////console.log(post_get_user,"id_cat_getuser")
        ///console.log(page_number,"page_number");
        const data_form = {post_id:String(post_get_user),page_number:page_number};

        axios.post(`${clientconfigwebapp.siteurl}api/v1/home-get-data/` ,data_form,config)
            .then((res) => {
                ///console.log(res.data.data_paged_info,"data_paged_infodata_paged_info");
              /////  console.log(res.data)

                if(String(res.data).length > 0) {


                    if(String(res.data.wallet_inventory).length > 0) {  setData_wallet_balance(res.data.wallet_inventory); }
                    if (!empty_bk(res.data.first_name_profile)) { setData_first_name_profile(res.data.first_name_profile); localStorage.setItem('first_name_Get',res.data.first_name_profile);    }
                    if (!empty_bk(res.data.last_name_profile)) { setData_last_name_profile(res.data.last_name_profile); localStorage.setItem('last_name_Get',res.data.last_name_profile);    }


                    if(String(res.data.data_category_box).length > 0) {  set_data_category_box(res.data.data_category_box); }

                    if(String(res.data.Requests_last).length > 0) {   set_data_Requests_last(res.data.Requests_last); }else{  set_data_Requests_last([]);  }
                    if(String(res.data.comments_last).length > 0) {   set_data_Comments_last(res.data.comments_last); }else{  set_data_Comments_last([]);  }

                    if(String(res.data.posts).length > 0) {   set_list_post_Data(res.data.posts); }else{  set_list_post_Data([]);  }





                }else{
                    if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                }

            }).catch((err) =>{
            /// Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 5156', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        });


////container_bk_fronts
//data_category_box

    }


    return (
        <Fragment>

            <style jsx>{`
                .footer {
                    margin-top: 0px !important;
                }

            `}</style>


            <ToastContainer/>


            <Header backgroundtr={"header-transparent"} wallet_balance={wallet_balance}
                    first_name_profile={first_name_profile} last_name_profile={last_name_profile}/>

            <Home_Baner_Search data_category_box={data_category_box}/>

            <div className={'box_front_master w-100 container_bk_fronts '}>
                <Home_Section_B />
            </div>


            <Home_Section_C data_category_box={data_category_box}/>

            <div className={'box_front_master w-100 container_bk_fronts '}>
                <div className="flex flex-wrap  pt-4 justify-around">
                    <Link reloadDocument={true} to={"/panel/request-reg"} className="w-full lg:w-6/12 px-2 mt-2">
                        <img src={baner_img_1} className={"rounded-[10px]"}/>
                    </Link>

                    <Link  reloadDocument={true} to={"/products"} className="w-full lg:w-6/12 px-2 mt-2">
                        <img src={baner_img_2} className={"rounded-[10px]"}/>
                    </Link>


                </div>
                </div>


                <div className={'box_front_master w-100 container_bk_fronts home-sec-c '}>
                    <Home_Section_D Requests_last={Requests_last}/>
                </div>


                <div className={'box_front_master w-100 container_bk_fronts home-sec-e'}>
                    <Home_Section_E/>
                </div>

                <div className={'box_front_master w-100 container_bk_fronts home-sec-f'}>

                    <Home_Section_F/>


                </div>


                <div className={'box_front_master w-100 container_bk_fronts home-sec-g'}>

                    <Home_Section_G Coments_last={Coments_last}/>


                </div>


                <div className={'box_front_master w-100 container_bk_fronts home-sec-h'}>

                    <img className={"bg_baner_bottom_home"} src={bg_baner_bottom_home} alt={""}/>


                </div>


                <Home_Section_I/>


                <Home_Section_J/>


                <Footercom/>

        </Fragment>
);
}

export default Home;